export const FEATURE_ROUTE_NAME = {
  PATIENT: 'index',
  DOCTOR: 'index-doctor',
  CLINIC: 'index-clinic',
}
